import React from 'react'

import { ZariContext } from '_zari/context'
import { AdminContext } from 'contexts/AdminContext'
import { Portlet } from '_zari/core'

import * as CodigosTransaccionesConstant from 'constants/codigosTransacciones'

import { IdGen } from 'utils'

import MainForm from './mainForm'

import * as OrdenCompraService from 'services/ordenCompra.service'

const NuevaOrdenPage = ({ history, match }) => {
  const __zariContext = React.useContext(ZariContext)
  const __adminContext = React.useContext(AdminContext)

  const [keyForm, setKeyForm] = React.useState(IdGen.newId())

  const editarDataRef = React.useRef({})

  // Bloquear acceso para Gerencia: solo puede aprobar, no crear ni editar OCs.
  const config = __adminContext.valoresConfiguracionUsuario || {}
  const esGerenciaPura = !!config.flagGerencia && !config.flagLogistica

  React.useEffect(() => {
    if (esGerenciaPura) {
      __zariContext.snack('warning', 'Gerencia solo puede aprobar Órdenes de Compra, no editarlas.')
      history.replace(`/${CodigosTransaccionesConstant.ORDENESCOMPRAS_APROBACION_LISTA}`)
    }
  }, [esGerenciaPura, history, __zariContext])

  const portletBreadcrumbs = React.useMemo(() => {
    if (match.params.id) {
      return [{ name: 'Ordenes de Compra', path: `/${CodigosTransaccionesConstant.ORDENESCOMPRAS_LISTA}` }, { name: 'Editar' }]
    }

    return [{ name: 'Ordenes de Compra', path: `/${CodigosTransaccionesConstant.ORDENESCOMPRAS_LISTA}` }, { name: 'Nueva' }]
  }, [match.params.id])

  const reiniciarFormulario = React.useCallback(() => {
    setKeyForm(IdGen.newId())
  }, [])

  React.useEffect(() => {
    if (esGerenciaPura) return
    if (match.params.id) {
      OrdenCompraService.obtenerxIdAsEdicion(match.params.id)
        .then(({ data }) => {
          editarDataRef.current = data
          setKeyForm(IdGen.newId())
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
    } else {
      setKeyForm(IdGen.newId())
    }
  }, [match.params, __zariContext, esGerenciaPura])

  if (esGerenciaPura) return null

  return (
    <Portlet>
      <Portlet.Header title='Ordenes de Compra' breadcrumbs={portletBreadcrumbs} />
      <Portlet.Body>
        <MainForm key={keyForm} history={history} reiniciarFormulario={reiniciarFormulario} editarData={editarDataRef.current} />
      </Portlet.Body>
    </Portlet>
  )
}

export default NuevaOrdenPage
